import { Injectable } from '@angular/core';
import { Action } from '../../../section/master/model/action';
import { ClinicalNotes, ClinicalReport } from '../model/clinical-notes';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import { HttpClientService } from '../../../shared/service/http/http-client.service';
import { CookiesService } from '../../../shared/service/cookies/cookies.service';

@Injectable()
export class ClinicalNotesService {

  http:HttpClientService;
  cookie : CookiesService;
  objAction : Action;
  data : ClinicalNotes[];
  clinicalData : ClinicalNotes;
  reportData : any;
  reportFiles : any[];
  constructor(http: HttpClientService, cook: CookiesService) {
     this.http = http;
     this.cookie = cook;
     this.objAction  = new Action(this.http,  this.cookie);
  }
  saveClinicalNotes(): Observable<ClinicalNotes> {
    this.objAction.header = null;
    this.objAction.data = this.data;

    this.objAction.path = 'api/ClinicalNotes/CreateClinicalNotes';
    return this.objAction.save();
  }
  saveClinicalNotesReport(): Observable<ClinicalReport> {
    this.objAction.header = null;
    this.objAction.data = this.reportData;
    this.objAction.files = this.reportFiles;
    this.objAction.path = 'api/ClinicalNotes/CreateClinicalNoteReport';
    return this.objAction.saveDataWithFiles();
  }
 getClinicalNotes(PatientId : number):   Observable<ClinicalNotes[]> {
    this.objAction.path = 'api/ClinicalNotes/GetClinicalNotesDetail?PatientId='+ PatientId;
    return this.objAction.get();
 }
 getClinicalInstruction(PatientId : number, AppointmentId: number):   Observable<ClinicalNotes[]> {
  this.objAction.path = 'api/ClinicalNotes/GetClinicalInstruction?PatientId='+ PatientId + '&AppointmentId='+ AppointmentId;
  return this.objAction.get();
}
 
 updateClinicalNotes(): Observable<ClinicalNotes> {
  this.objAction.header = null;
  this.objAction.data = this.data;
    this.objAction.path = 'api/ClinicalNotes/UpdateClinicalNotes';
    return this.objAction.update();
 }
 deleteClinicalNotes(usr: ClinicalNotes, patientId: number): Observable<ClinicalNotes> {
  this.objAction.header = null;
  this.objAction.path = 'api/ClinicalNotes/DeleteClinicalNotes?strPatientId=' + patientId+'&strAppointmentId=' + usr.AppointmentId;
  return this.objAction.delete();
}
deleteClinicalNotesReport(notesReportId: number, patientId: number, fileName : string): Observable<ClinicalNotes> {
  this.objAction.header = null;
  this.objAction.path = 'api/ClinicalNotes/DeleteClinicalNoteReport?strPatientId=' + patientId+'&strClinicalNoteReportId=' + notesReportId + '&fileName='+fileName;
  return this.objAction.delete();
}

}



// WEBPACK FOOTER //
// ./src/app/section/patient/service/clinical-notes.service.ts